import React, {useState} from "react";
import Home from "./pages/home/home";
import {MainPage} from "./pages/main/main";
import {SDKProvider} from "@telegram-apps/sdk-react";
import {Rules} from "./pages/rules/rules";

export default function App () {
  const [page, setPage] = useState('main')

  function setPageName(name) {
      setPage(name)
  }

  return (
      <React.Fragment>
        {page === 'tasks'
            ? <SDKProvider><MainPage /></SDKProvider>
            : <React.Fragment>
                {page === 'rules'
                    ? <Rules setPageName={setPageName} />
                    : <Home setPageName={setPageName} />
                }
              </React.Fragment>
        }
      </React.Fragment>
  );
};